export default __webpack_public_path__ + "static/testimonial-02-7a26dd09470fcdd7151589ad059b8d6b.png";